import React, { useState } from 'react';
import { apiFetch } from './api';

function Login({ onLogin }) {
  const [user, setUser] = useState('');
  const [pass, setPass] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const resp = await apiFetch('/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: user, password: pass })
      });
      const data = await resp.json();
      if (resp.ok && data.role) {
        onLogin(data);
      } else {
        setError('Acesso negado. Verifique suas credenciais.');
      }
    } catch (err) {
      setError('Erro ao conectar com o servidor.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card animate-fade">
        <div className="logo-section" style={{ justifyContent: 'center', marginBottom: '2rem' }}>
          <div className="logo-circle">SF</div>
          <div className="logo-text">StackFab</div>
        </div>
        <h2>Bem-vindo</h2>
        <p>Acesse o painel administrativo da oficina</p>
        
        <form onSubmit={handleSubmit}>
          <div className="login-input-group">
            <label>E-mail</label>
            <input 
              className="login-input"
              type="email"
              placeholder="seu@email.com" 
              value={user} 
              onChange={e => setUser(e.target.value)} 
              required
            />
          </div>
          <div className="login-input-group">
            <label>Senha</label>
            <input 
              className="login-input"
              type="password" 
              placeholder="••••••••" 
              value={pass} 
              onChange={e => setPass(e.target.value)} 
              required
            />
          </div>
          <button type="submit" className="btn-primary login-btn" disabled={loading}>
            {loading ? 'Entrando...' : 'Acessar Painel'}
          </button>
          {error && <div style={{ color: '#ff4444', marginTop: '1rem', fontSize: '0.9rem' }}>{error}</div>}
        </form>
      </div>
    </div>
  );
}

export default Login;
